/**
 * 仪表盘顶部控制模块，含快捷操作按钮。
 */
import { Link } from "react-router-dom";

import LoadingButton from "@/components/loading-button";
import { leaveRoom } from "@/services/remote/signaling";
import { closeRemote, restartIce } from "@/services/remote/webrtc";
import { useWebRTCStore } from "@/stores/remote";

type TopControlProps = {
	deviceId: string;
	showFileTransfer: boolean;
	showScreenWrapper: boolean;
	showLoader: boolean;
	toggleFileTransfer: () => void;
	setFullScreen: () => void;
	prepareRemote: () => void;
};

/**
 * 仪表盘顶部控制面板。
 * @param {TopControlProps} props 组件参数
 */
export default function TopControl({
	deviceId,
	showFileTransfer,
	showScreenWrapper,
	showLoader,
	toggleFileTransfer,
	setFullScreen,
	prepareRemote,
}: TopControlProps) {
	const { connectionState, isIceRestarting } = useWebRTCStore();

	const handleRestartIce = async () => {
		try {
			console.log("[TopControl] Initiating ICE restart...");
			useWebRTCStore.getState().setIceRestarting(true);
			await restartIce();
			console.log("[TopControl] ICE restart initiated successfully");
		} catch (error) {
			console.error("[TopControl] ICE restart failed:", error);
			// 可以在这里添加错误提示
		} finally {
			useWebRTCStore.getState().setIceRestarting(false);
		}
	};

	return (
		<div className="flex flex-row items-center justify-between pb-2.5">
			<div>
				<b>Device ID: {deviceId}</b> &nbsp; &nbsp;
				<span>{connectionState}</span>
			</div>
			<div className="flex flex-wrap gap-3">
				{connectionState === "connected" && !showFileTransfer && (
					<button
						type="button"
						onClick={toggleFileTransfer}
						className="btn btn-outline btn-sm"
					>
						File Transfer
					</button>
				)}

				{connectionState === "connected" && showFileTransfer && (
					<button
						type="button"
						onClick={toggleFileTransfer}
						className="btn btn-outline btn-sm"
					>
						Show Remote
					</button>
				)}

				{connectionState === "connected" && showScreenWrapper && (
					<button
						type="button"
						onClick={setFullScreen}
						className="btn btn-outline btn-sm"
					>
						Full Screen
					</button>
				)}

				{connectionState === "connected" && (
					<button
						type="button"
						onClick={handleRestartIce}
						disabled={isIceRestarting}
						className="btn btn-outline btn-sm"
					>
						{isIceRestarting ? "Restarting ICE..." : "Restart ICE"}
					</button>
				)}

				<LoadingButton
					text="Remote Control"
					onSubmit={prepareRemote}
					loading={showLoader}
					disabled={showLoader}
				/>

				<Link to="/">
					<button
						type="button"
						onClick={() => {
							leaveRoom();
						}}
						className="btn btn-outline btn-sm"
					>
						Exit
					</button>
				</Link>

				{connectionState === "connected" && (
					<button
						type="button"
						className="btn btn-outline btn-sm"
						onClick={closeRemote}
					>
						Disconnect
					</button>
				)}
			</div>
		</div>
	);
}
